const $ = jQuery.noConflict();

class HeaderMenu {
	constructor() {
		this.menu = $('.main-header__nav');
		this.menuItems = this.menu.find('> .menu > .menu-item-has-children');
		this.menuItemsLinks = this.menuItems.find('> a');
		this.search = $('.btn-search');
		this.languages = $('.btn-languages');
		this.hamburger = $('.btn-hamburger');
	}

	bindHeaderEvents() {
    	this.hamburger.on('click', this.toggleDesktopMegaMenu);
		this.search.on('click', this.toggleSearchBar);
		this.languages.on('click', this.toggleLanguagesDropdown);
		this.menuItemsLinks.on('click', this.toggleChildMenu);
		this.closeMenusOnClickOutside();
		this.bindMobileEvents();
		this.setGlobalsEvents();
	}

	getSetVariables() {
		const headerHeight = document.querySelector('.main-header__wrapper')?.offsetHeight;
		const alertBarHeight = document.querySelector('.alert-bar')?.offsetHeight ?? 0;

		if (headerHeight) {
			document.body.style.setProperty('--header-height', `${headerHeight}px`);
		}

		document.body.style.setProperty('--alert-bar-height', `${alertBarHeight}px`);
		
	}

	setGlobalsEvents() {
		$(window).on('load', () => {
			this.scrolledHeader();
			this.getSetVariables();
		});
		$(window).on('resize', this.getSetVariables);
		$(window).on('scroll', this.scrolledHeader);
	}

	submitSearchForm() {
		$('body').on('click', '#submit_form', function(){
			$(".search-form").submit();
		});
	}

	bindMobileEvents() {
		const mobileMenu = $('.main-header__nav');
		const mobileMenuItems = mobileMenu.find('> .menu > .menu-item-has-children');

		mobileMenuItems.each(function() {
			const menuLabel = $(this).find('> a').text();
			const subMenu = $(this).find('> .sub-menu ');

			if (subMenu.length > 0) {
				const headLi = `<li>
					<div class="menu-mobile-action">
						<div class="menu-mobile-action__title">${menuLabel}</div>
						<div class="menu-mobile-action__back">
							<a class="sub-menu-back" href="#">
								<i class="icon icon-chev-left"></i>
								<span>All</span>
							</a>
							<a class="sub-menu-close" href="#">
								<i class="icon icon-close"></i>
							</a>
						</div>
					</div>
				</li>`;

				subMenu.prepend(headLi);
			}
		});
		$("#menu-mobile-main-nav .mega-menu-wrapper > .container > .row").addClass('row-block');
		HeaderMenu.bindBackEvents();
  	}

	toggleChildMenu(e) {
		e.preventDefault();

		const subMenuWrapper = $(this).next('.sub-menu');
		if (!subMenuWrapper.hasClass('active')) {
			HeaderMenu.hideMegaMenu();
			HeaderMenu.showMegaMenu($(this).closest('.menu-item-has-children'));
		} else {
			HeaderMenu.hideMegaMenu();
		}
	}

	toggleDesktopMegaMenu(e) {
		e.preventDefault();

		if (!$('.menu-wrapper').hasClass('active')) {
			HeaderMenu.hideSearchBar();
			$('.btn-search').removeClass('open');
			HeaderMenu.activeMenu();
			$(this).addClass('open');
			$(this).closest('ul').addClass('active');
			$('body').removeClass('search-active');
			$('body').addClass('active');
			// opens first sub-menu
			if ($(window).width() >= 1199) {
				$('.main-header__nav li.menu-item-has-children:first-of-type > a').click();
			}
		} else {
			HeaderMenu.closeMenu();
			$(this).removeClass('open');
			$(this).closest('ul').removeClass('active');
			$('body').removeClass('active');
			$('#menu-header-main-menu').removeClass('list-active');
			HeaderMenu.hideMegaMenu();
		}
	}

	toggleSearchBar(e) {
		e.preventDefault();

		// Hide languages dropdown
		$('.languages-dropdown').removeClass('active');
		$('body').removeClass('languages-dropdown-active');

		if (!$('.search-wrapper').hasClass('active')) {
			if (
				$(window).width() < 1200 &&
				$('.btn-hamburger').hasClass('open')
			) {
				$('.btn-hamburger').trigger('click');
			}
			HeaderMenu.activeSearchBar();
			HeaderMenu.hideMegaMenu();
			$(this).addClass('open');
			HeaderMenu.closeMenu();
			$('.btn-hamburger').removeClass('open');
			$('.main-header__nav ul').removeClass('active');
			$('body').removeClass('active');
			$('#menu-header-main-menu').removeClass('list-active');
			$('body').addClass('search-active');
		} else {
			HeaderMenu.hideSearchBar();
			$(this).removeClass('open');
			$('body').removeClass('search-active');
		}
	}
	
	toggleLanguagesDropdown(e) {
		e.preventDefault();
		e.stopPropagation();

		// Hide search dropdown
		HeaderMenu.hideSearchBar();
		$(this).removeClass('open');
		$('body').removeClass('search-active');

		// Close header menu
		HeaderMenu.closeMenu();
		HeaderMenu.hideMegaMenu();
		$('.btn-hamburger').removeClass('open');
		$('body').removeClass('active');
		$('#menu-header-main-menu').removeClass('list-active');

		if (!$('.languages-dropdown').hasClass('active')){
			$('.languages-dropdown').addClass('active');
			$('body').addClass('languages-dropdown-active');
		} else {
			$('.languages-dropdown').removeClass('active');
			$('body').removeClass('languages-dropdown-active');
		}
	}

	scrolledHeader() {
		if ($(window).scrollTop() > 0) {
			$('body').addClass('header-scrolled');
		} else {
			$('body').removeClass('header-scrolled');
		}
	}

	closeMenusOnClickOutside() {
		document.addEventListener('click', function(event) {
			const target = event.target;
			const searchWrapper = document.querySelector('.search-wrapper');
			const searchButton = document.querySelector('.btn-search');
			const headerMenu = document.querySelector('.header-menu');
			const hamburger = document.querySelector('.btn-hamburger');

			// Check if the click target is outside both 'search-wrapper' and 'header-menu'
			if (!searchWrapper.contains(target) && !headerMenu.contains(target) && !hamburger.contains(target) && !searchButton.contains(target)) {
				HeaderMenu.closeMenu();
				HeaderMenu.hideSearchBar();
				HeaderMenu.hideMegaMenu();
				$('.btn-search').removeClass('open');
				$('.btn-hamburger').removeClass('open');
				$('.main-header__nav ul').removeClass('active');
				$('body').removeClass('active');
				$('#menu-header-main-menu').removeClass('list-active');
				$('body').removeClass('search-active');
			}

			// Check if the click target is outside the languages dropdown
			if ( $('body').hasClass('languages-dropdown-active') && !target.closest('.languages-dropdown') || target.classList.contains('glink') ) {
				$('.languages-dropdown').removeClass('active');
				$('body').removeClass('languages-dropdown-active');
			}
		});
	}

	static bindBackEvents() {
			$('.sub-menu-back').on('click', function(e) {
				e.preventDefault();

				HeaderMenu.hideMegaMenu();
			});

			$('.sub-menu-close').on('click', function(e) {
		e.preventDefault();

				HeaderMenu.closeMenu();
				$('.sub-menu-back').trigger('click');
				$('.btn-hamburger').removeClass('open');
				$('.btn-hamburger').removeClass('open');
				$('.main-header__nav ul').removeClass('active');
				$('body').removeClass('active');
				$('#menu-header-main-menu').removeClass('list-active');
		HeaderMenu.hideMegaMenu();
			});
	}

	static showMegaMenu(item) {
		const subMenuWrapper = item.find('.sub-menu');
		item.addClass('open');
		subMenuWrapper.addClass('active');
		subMenuWrapper.show();
		$('#menu-header-main-menu').addClass('list-active');
  	}

	static hideMegaMenu() {
		const activeSubMenu = $('.sub-menu.active');
		const activeSubMenuItems = $('.menu-item-has-children');
		activeSubMenu.hide();
		activeSubMenu.removeClass('active');
		activeSubMenuItems.removeClass('open');
		$('body').removeClass('open');
		$('#menu-header-main-menu').removeClass('list-active');
	}

	static activeMenu() {
		$('.menu-wrapper').addClass('active');
		$('.menu-wrapper').show();
		$('.menu-label').text("Close");
		$('body').addClass('header-active');
	}

	static closeMenu() {
		$('.menu-wrapper').removeClass('active');
		$('.menu-wrapper').hide();
		$('.menu-label').text("Menu");
		$('body').removeClass('header-active');
	}

	static activeSearchBar() {
		$('.search-wrapper').addClass('active');
		$('.search-wrapper').show();
		$('.main-header__search .search-label').text("Close");
		$('.btn-search .icon').addClass("icon-close");
		$('.btn-search .icon').removeClass("icon-search");
		
		// Focus the search input after a short delay to ensure the element is visible
		setTimeout(() => {
			$('.search-action input[type="search"]').focus();
		}, 100);
	}

	static hideSearchBar() {
		$('.search-wrapper').removeClass('active');
		$('.search-wrapper').hide();
		$('.main-header__search .search-label').text("Search");
		$('.btn-search .icon').addClass("icon-search");
		$('.btn-search .icon').removeClass("icon-close");
	}

	init() {
		this.getSetVariables();
		this.bindHeaderEvents();
		this.submitSearchForm();
	}
}

export default new HeaderMenu();
